import type { CommandTree } from "@app/commands";
import type Application from "@app/types/Application";
import type Context from "@core/Context/Context";
import type { Article } from "@core/FileStructue/Article/Article";
import type ContextualCatalog from "@core/FileStructue/Catalog/ContextualCatalog";
import type { Category } from "@core/FileStructue/Category/Category";
import type { AgentFileHandler } from "../agentFileHandler";

export type CopiedFile = { from: string; to: string };

export type UnreferencedFile = { storageHref: string; agentHref: string };

export type ArticleAdapterContext = {
	app: Application;
	ctx: Context;
	commands: CommandTree;
	catalog: ContextualCatalog;
	item: Article | Category;
	sessionId?: string;
	fileHandles?: AgentFileHandler;
	copiedFiles: CopiedFile[];
	unreferencedFiles: UnreferencedFile[];
};

export interface ArticleAdapter {
	expandToAgentView(storageMarkdown: string, context: ArticleAdapterContext): Promise<string>;
	applyAgentViewToStorage(agentMarkdown: string, context: ArticleAdapterContext): Promise<string>;
}

export const replaceTags = async (
	source: string,
	pattern: RegExp,
	replace: (match: RegExpExecArray) => Promise<string>,
): Promise<string> => {
	const parts: string[] = [];
	let lastIndex = 0;
	const re = new RegExp(pattern.source, pattern.flags);
	let match = re.exec(source);
	while (match !== null) {
		parts.push(source.slice(lastIndex, match.index));
		parts.push(await replace(match));
		lastIndex = match.index + match[0].length;
		match = re.exec(source);
	}
	parts.push(source.slice(lastIndex));
	return parts.join("");
};
